import { render, staticRenderFns } from "./PatientDiagramV2.vue?vue&type=template&id=489435e0&"
import script from "./PatientDiagramV2.vue?vue&type=script&lang=js&"
export * from "./PatientDiagramV2.vue?vue&type=script&lang=js&"
import style0 from "./PatientDiagramV2.vue?vue&type=style&index=0&id=489435e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports